import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { AboutComponent } from "./about/about.component";
import { FeatureInactivatedComponent } from "./feature-inactivated/feature-inactivated.component";
import { FunktionerComponent } from "./funktioner/funktioner.component";
import { InvalidUrlComponent } from "./invalid-url/invalid-url.component";
import { LoginComponent } from "./login/login/login.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { PermissionDeniedComponent } from "./permission-denied/permission-denied.component";
import { PermissiontoraskDeniedComponent } from "./permissiontorask-denied/permissiontorask-denied.component";
import { AktiviteterComponent } from "./start/aktiviteter/aktiviteter.component";
import { HandelserComponent } from "./start/handelser/handelser.component";
import { RecentComponent } from "./start/recent/recent.component";
import { StartComponent } from "./start/start.component";

@NgModule({
    imports: [
        RaskCommonModule,
        StartComponent,
        AboutComponent,
        LoginComponent,
        HandelserComponent,
        AktiviteterComponent,
        RecentComponent,
        InvalidUrlComponent,
        MaintenanceComponent,
        PermissionDeniedComponent,
        PermissiontoraskDeniedComponent,
        FeatureInactivatedComponent,
        FunktionerComponent
    ],
    providers: []
})
export class PageModule { }
